'use client';

import { Stack, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

import { Tag } from './market-rankings-badges';

/** 비교 카드 안의 블록 제목 — 아이콘 + 제목 + 개수 + 한 줄 설명 */
export default function SectionHeading({
  icon,
  iconColor,
  title,
  count,
  hint,
}: {
  icon: string;
  iconColor?: string;
  title: string;
  /** ⚠️ `0`도 그린다 — `null`일 때만 뺀다 */
  count?: number | string | null;
  hint?: string;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
      <Iconify icon={icon} width={20} sx={{ color: iconColor }} />
      <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      {count != null ? <Tag sx={{ bgcolor: 'grey.100', color: 'text.secondary' }}>{count}</Tag> : null}
      {hint ? <Typography variant="caption" sx={{ color: 'text.disabled' }}>{hint}</Typography> : null}
    </Stack>
  );
}
